const experience = [
	{
		id: "young-corp",
		date: "May 2024 — Present",
		role: "Software Engineer · Home Automation & Internal Tools",
		org: "Young Corporation",
		location: "Norcross, GA",
		accent: "primary",
		bullets: [],
	},
	{
		id: "gt-cse",
		date: "Sep 2021 — Apr 2024",
		role: "Senior Student Assistant · Tech Focus",
		org: "Georgia Tech Center for Student Engagement",
		location: "Atlanta, GA",
		accent: "secondary",
		bullets: [],
	},
	{
		id: "reflect",
		date: "Aug 2023 — Dec 2023",
		role: "Development Team Member",
		org: "Reflect! Research Team",
		location: "Atlanta, GA",
		accent: "tertiary",
		bullets: [],
	},
	{
		id: "longhorn",
		date: "Sep 2019 — Jun 2020",
		role: "Host",
		org: "LongHorn Steakhouse",
		location: "Lawrenceville, GA",
		accent: "primary",
		bullets: [],
	},
	{
		id: "teriyaki",
		date: "May 2017 — Nov 2017",
		role: "Cashier",
		org: "Teriyaki Box",
		location: "Lawrenceville, GA",
		accent: "secondary",
		bullets: [],
	},
];

export default experience;
